export default "__VITE_ASSET__CA7kghBl__"